/**
 * Converts cents to pretty dollars.
 *
 * full: show the full amount in dollars and cents
 *   -     1_00 =>     $1.00
 *   - 1_000_00 => $1,000.00
 *   - 1_234_00 => $1,234.00
 *   - 1_234_56 => $1,234.56
 *
 * full2: show the full amount in dollars but no decimal places if the amount is an integer
 *
 * round: show up to 2 decimal places for amount up to $1K,
 *        show up to 4 significant digits and up to 2 decimal places for amount more than $1K
 *        always round down
 *  -             1_00 =>   $1
 *  -             1_10 =>   $1.1
 *  -             1_23 =>   $1.23
 *  -         1_000_00 =>   $1K
 *  -         1_234_00 =>   $1.23K
 *  -         1_234_56 =>   $1.23K
 *  -        12_345_67 =>  $12.34K
 *  -       123_456_70 => $123.4K
 *  -     1_234_567_00 =>   $1.23M
 *  - 1_234_567_890_00 =>   $1.23B
 *
 * @param cents The amount in cents
 * @param roundDownMoreThan1k If true, rounds down more than 1k to the nearest 10
 */
export function centsToPrettyDollars(cents, mode = "full") {
    if (!Number.isInteger(cents)) {
        throw new Error("cents must be an integer");
    }
    if (cents < 0) {
        throw new Error("cents must be positive");
    }
    if (mode === "round") {
        if (cents < 1_000_00) {
            return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumSignificantDigits: 4,
                minimumFractionDigits: 0,
                roundingMode: "trunc",
            }).format(cents / 1_00);
        }
        if (cents < 1_000_000_00) {
            return (new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumSignificantDigits: 4,
                minimumFractionDigits: 0,
                roundingPriority: "lessPrecision",
                roundingMode: "trunc",
            }).format(cents / 1_000_00) + "K");
        }
        if (cents < 1_000_000_000_00) {
            return (new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumSignificantDigits: 4,
                minimumFractionDigits: 0,
                roundingPriority: "lessPrecision",
                roundingMode: "trunc",
            }).format(cents / 1_000_000_00) + "M");
        }
        return (new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumSignificantDigits: 4,
            minimumFractionDigits: 0,
            roundingPriority: "lessPrecision",
            roundingMode: "trunc",
        }).format(cents / 1_000_000_000_00) + "B");
    }
    if (mode === "full2") {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            roundingMode: "trunc",
        }).format(cents / 1_00);
    }
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        roundingMode: "trunc",
    }).format(cents / 1_00);
}
